export default __webpack_public_path__ + "static/media/chipsSelection.b39516d3.mp3";